<template>
  <div class="home">
    <v-container fluid>
      <v-card class="ma-5" shaped>
        <v-list two-line subheader v-for="[key, value] of Object.entries(navigation)" :key="key">
          <template v-if="((value.admin && isAdmin()) || !value.admin) && value.homeDisplay">
            <v-subheader
              inset
              class="font-weight-black red--text text--accent-2"
            >{{key.toUpperCase()}}</v-subheader>
            <v-list-item v-for="item in value.items" :key="item.title" @click="goTo(item.path)">
              <v-list-item-avatar>
                <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="red accent-2">mdi-arrow-right-bold-circle</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Roles from "@/router/roles";
import { mapState } from "vuex";

export default {
  name: "Home",
  computed: {
    ...mapState({
      navigation: (state) => state.navigation.all,
    }),
  },
  methods: {
    goTo(route) {
      if (this.$router.currentRoute.path !== route) {
        this.$router.push(route);
      }
    },
    isAdmin() {
      return this.$auth.getUserRoles().includes(Roles.Admin) || this.$auth.getUserRoles().includes(Roles.OrderPipelineAdministrator);
    },
  },
};
</script>
